<template>
    <div>
      <router-view></router-view>
      <footer class="footer">
        <div class="footer-item">
          <router-link to="/kaoq" class="link">
            <img class="icon" src="@/assets/yuyue.png" alt="Logo" />
            <span class="iconfont icon-visitor"></span>
            <scan class="di">考勤管理</scan>
          </router-link>
        </div>
        <div class="footer-item">
          <router-link to="/daka" class="link">
            <img class="icon" src="@/assets/shenpi.png" alt="Logo" />
            <span class="iconfont icon-approval"></span>
            <scan class="di">打卡记录</scan>
          </router-link>
        </div>
      </footer>
    </div>
  </template>
  
  <script>
  
  export default {
    mounted() {
        
    },
    methods: {
        
    }
  };
  </script>
  
  <style scoped>
  .footer {
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #ffffff;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 60px; /* 底部导航栏的高度 */
    border-top: 1px solid #e0e0e0;
    box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1); /* 阴影效果 */
    z-index: 1000; /* 确保在内容之上 */
  }
  
  .footer-item {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .di {
    font-size: 13px;
    font-weight: bold;
  }
  
  .link {
    text-decoration: none; /* 移除链接下的横线 */
    color: #666; /* 默认文字颜色 */
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .link.router-link-exact-active,
  .link:hover {
    color: #007bff; /* 激活状态或悬停时的文字颜色 */
  }
  
  .icon {
    width: 18px; /* Logo大小 */
    height: 18px;
    margin-bottom: 2px; /* Logo与文字之间的间距 */
  }
  
  .iconfont {
    font-size: 24px;
    margin-bottom: 5px;
  }
  
  p {
    margin: 0;
  }
  </style>